import { render, staticRenderFns } from "./AddCouponRule.vue?vue&type=template&id=452535a4&scoped=true"
import script from "./AddCouponRule.vue?vue&type=script&lang=js"
export * from "./AddCouponRule.vue?vue&type=script&lang=js"
import style0 from "./AddCouponRule.vue?vue&type=style&index=0&id=452535a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452535a4",
  null
  
)

export default component.exports